import { useContext } from 'react';
import { ResponsiveContext } from '../root/ResponseProvider';
const userResponsive = () => {
    const responsiveClass = useContext(ResponsiveContext);
    return [responsiveClass];
};
export default userResponsive;
